declare namespace $ {

	type $mol_view__style_shm_hitalama_map_widget_panel_1 = $mol_type_enforce<
		({ 
			'alignSelf': string,
			'width': string,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_panel_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_panel['controls'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_map_widget_panel extends $shm_hitalama_map_widget_float {
		controls( ): readonly(any)[]
		Panel_body( ): $mol_view
		size_sync( ): any
		scrollable( ): boolean
		content( ): readonly(any)[]
		head_view( ): readonly(any)[]
		edges( ): readonly(any)[]
		outline( ): readonly(any)[]
		toolbar( ): readonly(any)[]
		auto( ): readonly(any)[]
		style( ): ({ 
			'contain': string,
			'overflow': string,
		})  & ReturnType< $shm_hitalama_map_widget_float['style'] >
	}
	
}

//# sourceMappingURL=panel.view.tree.d.ts.map